<template>
    <div>
        <Box :title="'申请列表('+Total+'条)'" :SearchParams="IsSee" @SearchParams="IsSee=true">
            <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee=false">
                <div class="items listItems" v-for="(item, index) in list"
                    @click="$router.push({name: 'addAdverseEvent', params: {item:item,isShow:true} })">
                    <div class="itemTopBox">
                        <div>
                            <span>报告单号</span>
                            <span>{{item.BG_ID}}</span>
                        </div>
                        <div>
                            <span>报告科室</span>
                            <span>{{item.KSMC}}</span>
                        </div>
                        <div>
                            <span>报告日期</span>
                            <span>{{item.BG_Date}}</span>
                        </div>
                        <div>
                            <span>设备名称</span>
                            <span>{{item.SBMC}}</span>
                        </div>
                        <div>
                            <span>患者姓名</span>
                            <span>{{item.PAT_NAME}}</span>
                        </div>
                        <div>
                            <span>事件结果</span>
                            <span>{{item.EVENT_RESULT}}</span>
                        </div>
                        <div>
                            <span>上报人员</span>
                            <span>{{item.TBRMC}}</span>
                        </div>
                    </div>
                    <div v-if="item.ZT=='1'||item.ZT=='2'" class="itemBottomBox"><!--状态为审核中和已审核不能修改和删除-->
                        <div @click="$router.push({name: 'addAdverseEvent', params: {item:item,isShow:false} })">查看
                        </div>
                    </div>
                    <div v-else class="itemBottomBox">
                        <div @click.stop="_delete(item, index)">删除</div>
                        <div>修改</div>
                        <div v-if="isBader=='1'" @click="Audit(item,index)">审核</div>
                    </div>

                </div>
            </LoadingFooter>
            <transition name="fade">
                <div class="menu" v-if="IsSee">
                    <Field title="设备名称" placeholder="请输入" @onMessage="value => search.SBMC = value" />
                    <Field title="上报人" placeholder="请输入" @onMessage="value => search.SBRXM = value" />
                    <Field title="患者名称" placeholder="请输入" @onMessage="value => search.HZMC = value" />

                    <Field title="审核状态" type="teb" :tabSelected="search.SHJG" :data="[{id:'0',name:'未审核'},
                {id:'1',name:'已审核'},{id:'',name:'全部'}]" @onMessage="value => search.SHJG = value.id" />

                    <Field title="申请科室" :text="search.SQKSMC" name="departmentList"
                        @manuconfirm="search.SQKS=arguments[0].a,search.SQKSMC=arguments[0].b" type="manufacturer"
                        placeholder="请选择" />
                    <Field title="开始时间" :text="search.StartTime" placeholder="请选择" type="calendar"
                        @onMessage="value => search.StartTime = value" />
                    <Field title="结束时间" :text="search.EndTime" placeholder="请选择" type="calendar"
                        @onMessage="value => search.EndTime = value" />
                    <div class="search" @click="serach">查询</div>
                </div>
            </transition>
        </Box>
        <div class="footer">
            <div class="button" @click="$router.push({name:'addAdverseEvent'})">新增申请</div>
        </div>
    </div>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'adverseEventList',
        data() {
            return {
                params: {
                    YWSFBZ: '有'
                },
                search: { //搜索条件
                    SQKS: null,
                    SBMC: null,
                    SBRXM: '',
                    HZMC: '',
                    SHJG: '',
                    StartTime: '',
                    EndTime: ''
                },
                isBader: 0,
                loading: true,
                finished: false,
                IsSee: false,
                list: [],
                page: 10,
                Total: 0
            }
        },
        components: {
            Box,
            Field,
            LoadingFooter
        },
        activated() {
            this.loadDataDefault();
        },
        methods: {
            serach() { //搜索条件
                this.list = [];
                this.page = 10;
                this.IsSee = false;
                this.loadDataDefault();
            },
            loadDataDefault() {
                this.$post('api/AdverseEvent/AdverseEventList', {
                    PageIndex: 1,
                    PageSize: this.page,
                    StarTime: this.search.StartTime,
                    EndTime: this.search.EndTime,
                    SB_BH: this.search.SBMC,
                    SBRXM: this.search.SBRXM,
                    HZMC: this.search.HZMC,
                    GKHM: this.$UserInfo.UserId,
                    BG_KS: this.search.SQKS,
                    SHJG: this.search.SHJG,
                    Token: 'YTDF5EF3A6174564E5981A446158F106'
                }).then(result => {
                    this.Total = result.total;
                    this.list = result.rows;
                    this.isBader = result.isBader;
                    if (this.page <= this.Total) {
                        this.loading = false;
                        this.finished = false;
                    } else this.finished = true;
                })
            },
            onLoad() { //下拉加载页面
                if (!this.loading && !this.finished) {
                    this.page += 5;
                    this.loadDataDefault();
                }
            },
            _delete(item, index) { //删除申请单
                this.$Dialog.confirm({
                    message: "确定删除?"
                }).then(() => {
                    this.$get('api/AdverseEvent/DeleteAdverseEvent', {
                        Token: 'YTDF5EF3A6174564E5981A446158F106',
                        BG_ID: item.BG_ID
                    }).then(result => {
                        if (result.Status) {
                            this.$Toast(result.Msg);
                            this.list.splice(index, 1);
                            this.Total = this.Total - 1;
                        } else {
                            this.$Toast(result.Msg);
                        }
                    });
                }).catch(() => {})
            },
            Audit(item, index) { //审核申请单
                this.$Dialog.confirm({
                    message: "确认审核?"
                }).then(() => {
                    this.$post('api/AdverseEvent/AuditsAdverseEvent', {
                        Token: 'YTDF5EF3A6174564E5981A446158F106',
                        GKHM: this.$UserInfo.GKHM,
                        SHJG: "1", //审核结果 1通过 2否决
                        SHYJ: "通过", //审核意见
                        BGBH: item.BG_ID
                    }).then(result => {
                        if (result.Status) {
                            this.$Toast(result.Msg);
                            this.list.splice(index, 1);
                            this.Total = this.Total - 1;
                        } else {
                            this.$Toast(result.Msg);
                        }
                    });
                }).catch(() => {})

            }
        },
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;
        transition: all .5s;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding: 36px 30px;

        .itemTopBox {
            border-bottom: 2px solid #eee;

            div {
                display: flex;
                align-items: center;
                font-size: 28px;
                margin-bottom: 32px;

                span:first-child {
                    flex: 1;
                    color: #858585;
                }

                span:last-child {
                    color: $TEXT-DARK-COLOR;
                    font-weight: bold;
                    width: 326px;
                    text-align: right;
                }
            }
        }

        .itemBottomBox {
            margin-top: 32px;
            display: flex;
            align-items: center;
            justify-content: center;

            div {
                width: 300px;
                height: 80px;
                border-radius: 8px;
                text-align: center;
                line-height: 80px;
                font-size: 26px;

                &:first-child {
                    background: #dedede;
                    color: #858585;
                    margin-right: 40px;
                }

                &:nth-child(2) {
                    background: $THEME-COLOR;
                    color: #fff;
                    margin-right: 40px;
                }

                &:last-child {
                    background: $THEME-COLOR;
                    color: #fff;
                }
            }
        }
    }

    .listLength {
        font-size: 29px;
        color: #4a4a4a;
        margin-bottom: 18px;
        margin-left: 30px;
        top: 95px;

        span {
            margin-left: 20px;
            color: $THEME-COLOR;
            font-weight: bold;
        }
    }

    .listLength {
        //top: 930px;
    }

    .listItems:nth-child(3) {
        margin-top: 0px;
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 114px;
        background: $BACKGROUND-COLOR;
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
        padding-top: 24px;

        .button {
            width: 690px;
            height: 96px;
            background: $THEME-COLOR;
            border-radius: 8px;
            color: $TEXT-LIGHT-COLOR;
            font-size: 30px;
            text-align: center;
            line-height: 96px;
            margin: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/adverseEvent/adverseEventList.vue